var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43,
    height: 44,
    viewBox: "0 0 43 44",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_92_6045)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.62
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.5 43.5801C33.3741 43.5801 43 33.9542 43 22.0801C43 10.206 33.3741 0.580078 21.5 0.580078C9.62588 0.580078 0 10.206 0 22.0801C0 33.9542 9.62588 43.5801 21.5 43.5801Z",
    fill: "#B2B3F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5 43.0801C33.098 43.0801 42.5 33.6781 42.5 22.0801C42.5 10.4821 33.098 1.08008 21.5 1.08008C9.90202 1.08008 0.5 10.4821 0.5 22.0801C0.5 33.6781 9.90202 43.0801 21.5 43.0801Z",
    stroke: "#565ADD"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M17.5586 26.922L12.3396 21.703L10.5996 23.443L17.5586 30.402L32.4706 15.49L30.7306 13.75L17.5586 26.922Z",
    fill: "#565ADD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_92_6045"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43,
    height: 43,
    fill: "white",
    transform: "translate(0 0.580078)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.603eb1cb2364fbcf1c721144b82c30c5.svg";
export { ForwardRef as ReactComponent };